import PortalTable from './PortalTableContainer';

export default PortalTable;
